import { render } from "./IndividualItemInsert.vue?vue&type=template&id=465a372a"
import script from "./IndividualItemInsert.vue?vue&type=script&lang=js"
export * from "./IndividualItemInsert.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__